var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"back-btn-wrapper btn-inline text-medium flex-center pointer",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('back')}}},[_c('i',{staticClass:"arrow-left-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }